import React from 'react'
import { ProjectTeaserWithTracking, ProjectPreview, NoResult } from 'shared'

export class ProjectList extends React.Component {
  renderPreviews = () => {
    if (!this.props.isLoading) return null

    return [...Array(this.props.numberOfPreviews || 3).keys()].map(
      (i) => <div className="col-md-8 m-b" key={ i }>
          <ProjectPreview />
        </div>
    )
  }

  renderProjects = () => {
    if (!this.props.isLoading && this.props.projects.length == 0) {
      return <NoResult />
    }

    return this.props.projects.map(
      (project, index) => <div className="col-md-8 m-b" key={ index }>
          <ProjectTeaserWithTracking
            project={ project }
            index={ index }
            trackingPath={ this.props.trackingPath }
            sourceProjectID={ this.props.sourceProjectID }
            openInTab={ this.props.openInTab }
          />
        </div>
    )
  }

  render() {
    return <div className="row">
      { this.renderProjects() }
      { this.renderPreviews() }
    </div>
  }
}
